// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Shared styling for Settings Tabs
 */
.IQE81qKw0X2pkSg8eXJg {
	display: flex;
	flex-direction: column;
	gap: 22px;
}

.KMWKQBXtCiBFcqYmi0U7 {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.gd8olvIhBUwrxoBg2w28 {
	font-size: 11px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.06em;
	color: var(--vnsc-text-secondary, #94a3b8);
	margin: 0 0 4px 0;
	padding-bottom: 6px;
	border-bottom: 1px solid var(--vnsc-border, #1e293b);
}

.DHkk5S2NjgbhfMu2qDiG {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	min-height: 32px;
}

.VJ4xDGy1dcA8LplKvqxk {
	display: flex;
	align-items: center;
	gap: 12px;
}

.iz8uChkZW9QXM8RAOSIM {
	font-size: 13px;
	color: var(--vnsc-text-primary, #f1f5f9);
	font-weight: 500;
	display: flex;
	align-items: center;
	gap: 8px;
}

.Su2dlNXQrczs5hrY5Bnj {
	font-size: 11px;
	color: var(--vnsc-text-secondary, #94a3b8);
	margin-top: 2px;
}

.acLEV3vzw0FBfsduF46R {
	display: flex;
	align-items: center;
	gap: 10px;
}

.pofVzjn_XLai8g7fwp8Y,
.mdOZoXeTVo8i0Y_VISdN {
	padding: 6px 10px;
	border-radius: 4px;
	border: 1px solid var(--vnsc-border, #1e293b);
	background: var(--vnsc-bg-secondary, #131d2a);
	color: var(--vnsc-text-primary, #f1f5f9);
	font-size: 12px;
	outline: none;
	transition: border-color 0.15s ease;
	box-sizing: border-box;
}

.pofVzjn_XLai8g7fwp8Y:focus,
.mdOZoXeTVo8i0Y_VISdN:focus {
	border-color: var(--vnsc-accent, #38bdf8);
}

.mdOZoXeTVo8i0Y_VISdN {
	cursor: pointer;
}

.vyuEuWTnPd0zXD1r53qD {
	width: 90px;
	text-align: right;
}

.Oumloo9ECKQV6sru96Zb {
	width: 16px;
	height: 16px;
	cursor: pointer;
	accent-color: var(--vnsc-accent, #2563eb);
}

.dIcE9XTnCCgF9UqWgHYF {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	width: 28px;
	height: 28px;
	border: 1px solid var(--vnsc-border, #1e293b);
	border-radius: 4px;
	background: transparent;
	cursor: pointer;
	padding: 0;
}

.dIcE9XTnCCgF9UqWgHYF::-webkit-color-swatch-wrapper {
	padding: 2px;
}

.dIcE9XTnCCgF9UqWgHYF::-webkit-color-swatch {
	border: none;
	border-radius: 2px;
}

.xUFRD6w2gKrY5vDurTHe {
	display: inline-flex;
	border: 1px solid var(--vnsc-border, #1e293b);
	border-radius: 4px;
	overflow: hidden;
	background: var(--vnsc-bg-secondary, #131d2a);
}

.AZzD5AYA6XJ8BZNApKMa {
	padding: 5px 10px;
	font-size: 12px;
	font-weight: 500;
	background: transparent;
	border: none;
	color: var(--vnsc-text-secondary, #94a3b8);
	cursor: pointer;
	transition: all 0.15s ease;
}

.AZzD5AYA6XJ8BZNApKMa:not(:last-child) {
	border-right: 1px solid var(--vnsc-border, #1e293b);
}

.fiXyBuPYj_5h_dTMndS6 {
	background: var(--vnsc-accent, #2563eb);
	color: #ffffff;
}

.EUxunEQof4ONgGBOCuuQ {
	padding: 12px 14px;
	background: var(--vnsc-bg-secondary, #131d2a);
	border: 1px solid var(--vnsc-border, #1e293b);
	border-radius: 6px;
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.NPSk_oxv2AO5s28CbxRm {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.Npy1ckvXVDOXjmgccwX7 {
	font-size: 13px;
	font-weight: 600;
	color: var(--vnsc-text-primary, #f1f5f9);
}

.cWIjhlq6kAZBkpEuGTXR {
	display: flex;
	align-items: center;
	gap: 6px;
}

.DruYbIF12eISAcp1ucoZ {
	padding: 4px 8px;
	font-size: 11px;
	border-radius: 4px;
	border: 1px solid var(--vnsc-border, #1e293b);
	background: transparent;
	color: var(--vnsc-text-secondary, #94a3b8);
	cursor: pointer;
	transition: all 0.15s ease;
}

.DruYbIF12eISAcp1ucoZ:hover {
	background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.08));
	color: var(--vnsc-text-primary, #ffffff);
}

`, "",{"version":3,"sources":["webpack://./src/widget/components/settings/tabs/settingsTabs.module.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,sBAAsB;CACtB,0CAA0C;CAC1C,iBAAiB;CACjB,mBAAmB;CACnB,oDAAoD;AACrD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,wCAAwC;CACxC,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,eAAe;CACf,0CAA0C;CAC1C,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;;CAEC,iBAAiB;CACjB,kBAAkB;CAClB,6CAA6C;CAC7C,6CAA6C;CAC7C,wCAAwC;CACxC,eAAe;CACf,aAAa;CACb,mCAAmC;CACnC,sBAAsB;AACvB;;AAEA;;CAEC,yCAAyC;AAC1C;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,yCAAyC;AAC1C;;AAEA;CACC,wBAAwB;CACxB,qBAAqB;CACrB,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,6CAA6C;CAC7C,kBAAkB;CAClB,uBAAuB;CACvB,eAAe;CACf,UAAU;AACX;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,6CAA6C;CAC7C,kBAAkB;CAClB,gBAAgB;CAChB,6CAA6C;AAC9C;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,uBAAuB;CACvB,YAAY;CACZ,0CAA0C;CAC1C,eAAe;CACf,0BAA0B;AAC3B;;AAEA;CACC,mDAAmD;AACpD;;AAEA;CACC,uCAAuC;CACvC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,6CAA6C;CAC7C,6CAA6C;CAC7C,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;AAC/B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,6CAA6C;CAC7C,uBAAuB;CACvB,0CAA0C;CAC1C,eAAe;CACf,0BAA0B;AAC3B;;AAEA;CACC,2DAA2D;CAC3D,wCAAwC;AACzC","sourcesContent":["/**\r\n * Shared styling for Settings Tabs\r\n */\r\n.tabContainer {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 22px;\r\n}\r\n\r\n.section {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 12px;\r\n}\r\n\r\n.sectionTitle {\r\n\tfont-size: 11px;\r\n\tfont-weight: 700;\r\n\ttext-transform: uppercase;\r\n\tletter-spacing: 0.06em;\r\n\tcolor: var(--vnsc-text-secondary, #94a3b8);\r\n\tmargin: 0 0 4px 0;\r\n\tpadding-bottom: 6px;\r\n\tborder-bottom: 1px solid var(--vnsc-border, #1e293b);\r\n}\r\n\r\n.row {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tgap: 16px;\r\n\tmin-height: 32px;\r\n}\r\n\r\n.rowStart {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 12px;\r\n}\r\n\r\n.label {\r\n\tfont-size: 13px;\r\n\tcolor: var(--vnsc-text-primary, #f1f5f9);\r\n\tfont-weight: 500;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n}\r\n\r\n.subLabel {\r\n\tfont-size: 11px;\r\n\tcolor: var(--vnsc-text-secondary, #94a3b8);\r\n\tmargin-top: 2px;\r\n}\r\n\r\n.controlGroup {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 10px;\r\n}\r\n\r\n.input,\r\n.select {\r\n\tpadding: 6px 10px;\r\n\tborder-radius: 4px;\r\n\tborder: 1px solid var(--vnsc-border, #1e293b);\r\n\tbackground: var(--vnsc-bg-secondary, #131d2a);\r\n\tcolor: var(--vnsc-text-primary, #f1f5f9);\r\n\tfont-size: 12px;\r\n\toutline: none;\r\n\ttransition: border-color 0.15s ease;\r\n\tbox-sizing: border-box;\r\n}\r\n\r\n.input:focus,\r\n.select:focus {\r\n\tborder-color: var(--vnsc-accent, #38bdf8);\r\n}\r\n\r\n.select {\r\n\tcursor: pointer;\r\n}\r\n\r\n.inputNumber {\r\n\twidth: 90px;\r\n\ttext-align: right;\r\n}\r\n\r\n.checkbox {\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\tcursor: pointer;\r\n\taccent-color: var(--vnsc-accent, #2563eb);\r\n}\r\n\r\n.colorPicker {\r\n\t-webkit-appearance: none;\r\n\t-moz-appearance: none;\r\n\tappearance: none;\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tborder: 1px solid var(--vnsc-border, #1e293b);\r\n\tborder-radius: 4px;\r\n\tbackground: transparent;\r\n\tcursor: pointer;\r\n\tpadding: 0;\r\n}\r\n\r\n.colorPicker::-webkit-color-swatch-wrapper {\r\n\tpadding: 2px;\r\n}\r\n\r\n.colorPicker::-webkit-color-swatch {\r\n\tborder: none;\r\n\tborder-radius: 2px;\r\n}\r\n\r\n.segmented {\r\n\tdisplay: inline-flex;\r\n\tborder: 1px solid var(--vnsc-border, #1e293b);\r\n\tborder-radius: 4px;\r\n\toverflow: hidden;\r\n\tbackground: var(--vnsc-bg-secondary, #131d2a);\r\n}\r\n\r\n.segmentedBtn {\r\n\tpadding: 5px 10px;\r\n\tfont-size: 12px;\r\n\tfont-weight: 500;\r\n\tbackground: transparent;\r\n\tborder: none;\r\n\tcolor: var(--vnsc-text-secondary, #94a3b8);\r\n\tcursor: pointer;\r\n\ttransition: all 0.15s ease;\r\n}\r\n\r\n.segmentedBtn:not(:last-child) {\r\n\tborder-right: 1px solid var(--vnsc-border, #1e293b);\r\n}\r\n\r\n.segmentedBtnActive {\r\n\tbackground: var(--vnsc-accent, #2563eb);\r\n\tcolor: #ffffff;\r\n}\r\n\r\n.card {\r\n\tpadding: 12px 14px;\r\n\tbackground: var(--vnsc-bg-secondary, #131d2a);\r\n\tborder: 1px solid var(--vnsc-border, #1e293b);\r\n\tborder-radius: 6px;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 10px;\r\n}\r\n\r\n.cardHeader {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n}\r\n\r\n.cardTitle {\r\n\tfont-size: 13px;\r\n\tfont-weight: 600;\r\n\tcolor: var(--vnsc-text-primary, #f1f5f9);\r\n}\r\n\r\n.cardActions {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 6px;\r\n}\r\n\r\n.btnSm {\r\n\tpadding: 4px 8px;\r\n\tfont-size: 11px;\r\n\tborder-radius: 4px;\r\n\tborder: 1px solid var(--vnsc-border, #1e293b);\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-secondary, #94a3b8);\r\n\tcursor: pointer;\r\n\ttransition: all 0.15s ease;\r\n}\r\n\r\n.btnSm:hover {\r\n\tbackground: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.08));\r\n\tcolor: var(--vnsc-text-primary, #ffffff);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabContainer": `IQE81qKw0X2pkSg8eXJg`,
	"section": `KMWKQBXtCiBFcqYmi0U7`,
	"sectionTitle": `gd8olvIhBUwrxoBg2w28`,
	"row": `DHkk5S2NjgbhfMu2qDiG`,
	"rowStart": `VJ4xDGy1dcA8LplKvqxk`,
	"label": `iz8uChkZW9QXM8RAOSIM`,
	"subLabel": `Su2dlNXQrczs5hrY5Bnj`,
	"controlGroup": `acLEV3vzw0FBfsduF46R`,
	"input": `pofVzjn_XLai8g7fwp8Y`,
	"select": `mdOZoXeTVo8i0Y_VISdN`,
	"inputNumber": `vyuEuWTnPd0zXD1r53qD`,
	"checkbox": `Oumloo9ECKQV6sru96Zb`,
	"colorPicker": `dIcE9XTnCCgF9UqWgHYF`,
	"segmented": `xUFRD6w2gKrY5vDurTHe`,
	"segmentedBtn": `AZzD5AYA6XJ8BZNApKMa`,
	"segmentedBtnActive": `fiXyBuPYj_5h_dTMndS6`,
	"card": `EUxunEQof4ONgGBOCuuQ`,
	"cardHeader": `NPSk_oxv2AO5s28CbxRm`,
	"cardTitle": `Npy1ckvXVDOXjmgccwX7`,
	"cardActions": `cWIjhlq6kAZBkpEuGTXR`,
	"btnSm": `DruYbIF12eISAcp1ucoZ`
};
export default ___CSS_LOADER_EXPORT___;
